<template>
  <div>
    <h2>単価設定</h2>

    <v-container class="pt-6" v-if="setting">
      <v-row>
        <v-col cols="6">
          <h4>写真単価</h4>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="setting.photoPrice"
            suffix="円"
            variant="outlined"
            hide-details=""
            density="compact"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <h4>写真L単価</h4>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="setting.photoLargePrice"
            suffix="円"
            variant="outlined"
            hide-details=""
            density="compact"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <h4>写真2L単価</h4>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="setting.photo2LargePrice"
            suffix="円"
            variant="outlined"
            hide-details=""
            density="compact"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <h4>写真KG単価</h4>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="setting.photoKgPrice"
            suffix="円"
            variant="outlined"
            hide-details=""
            density="compact"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <h4>動画30秒単価</h4>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="setting.movie30Price"
            suffix="円"
            variant="outlined"
            hide-details=""
            density="compact"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <h4>動画60秒単価</h4>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="setting.movie60Price"
            suffix="円"
            variant="outlined"
            hide-details=""
            density="compact"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <h4>動画90秒単価</h4>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="setting.movie90Price"
            suffix="円"
            variant="outlined"
            hide-details=""
            density="compact"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <h4>動画120秒単価</h4>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="setting.movie120Price"
            suffix="円"
            variant="outlined"
            hide-details=""
            density="compact"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <h4>動画150秒単価</h4>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="setting.movie150Price"
            suffix="円"
            variant="outlined"
            hide-details=""
            density="compact"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <div class="d-flex justify-center align-center pt-8">
      <v-btn @click="updateSetting" :loading="loading" color="primary" large depressed>
        更新
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import { UpdateSettingRequest } from "@/api/ApiMemoru";
import LocalDataService from "@/service/LocalDataService";
import { memoruModule } from "@/store/dataModule/memoruModule";
import { defineComponent } from "vue";

export default defineComponent({
  name: "MemoruSetting",

  async mounted() {
    await this.listSetting();
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    setting: {
      get(): UpdateSettingRequest | null {
        return memoruModule.setting;
      },
      set(value: UpdateSettingRequest) {
        memoruModule.setSetting(value);
      },
    },
  },

  methods: {
    async listSetting() {
      this.loading = true;
      const companyId = LocalDataService.getCompanyId();
      if (companyId) {
        await memoruModule
          .listSetting({
            companyId,
          })
          .catch();
      }
      this.loading = false;
    },
    async updateSetting() {
      this.loading = true;
      const companyId = LocalDataService.getCompanyId();
      if (companyId && this.setting) {
        this.setting.companyId = companyId;
        const response = await memoruModule.updateSetting().catch(() => (this.loading = false));
        if (response) {
          alert("更新しました");
        }
      }
      this.loading = false;
    },
  },
});
</script>
